import { render, staticRenderFns } from "./EntityDetailHeader.vue?vue&type=template&id=646ce356&scoped=true"
import script from "./EntityDetailHeader.vue?vue&type=script&lang=ts"
export * from "./EntityDetailHeader.vue?vue&type=script&lang=ts"
import style0 from "./EntityDetailHeader.vue?vue&type=style&index=0&id=646ce356&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646ce356",
  null
  
)

export default component.exports